import { EvoGenericWidget } from "../models/evo-generic-widget";
import { SimpleHttp } from "../../simple-http";

export class EvoWidgetBootstrapService {
    private widget: EvoGenericWidget;
    private cacheBustedFilesNames: {[key: string]: string};
    constructor() {

    }

    public bootstrapWidget(widget: EvoGenericWidget, elementWrapper: HTMLElement): void {
        // Get the <db-generic-widget> DOM node and it's parent DOM node
        const widgetNode = elementWrapper.querySelectorAll('db-generic-widget')[0];
        const widgetParentNode = widgetNode.parentNode;
        const appBundleName = widget.attributes.appBundleName;
        const appSelector = widget.attributes.appSelector;
        let appElement: HTMLElement;
        if (appSelector && appBundleName) {
            // Remove the <db-generic-widget> DOM node
            widgetParentNode.removeChild(widgetNode);


            // Create the DOM node the widget expects, based on the portalManager properties
            appElement = document.createElement(appSelector);
            Object.defineProperty(appElement, 'widget', {
                enumerable: false,
                configurable: false,
                writable: false,
                value: this.widget
            });

            widgetParentNode.appendChild(appElement);
        }
        // Initiate the Widget
        if (widget.type === 'backbase') {
            this.initiateLegacyBackbaseWidget(widget, appElement);
        } else {
            this.initiateLatestAngularWidget(widget, elementWrapper);
        }
    }

    private async initiateLegacyBackbaseWidget(widget: EvoGenericWidget, elementWrapper: HTMLElement) {
        
        const self = this;
        const serverRoot = widget.serverRoot || (<any>window).b$.portal.config.serverRoot || '/portalserver2';
        const appBundleName = widget.attributes.appBundleName;
        const appSelector = widget.attributes.appSelector;

        // Build the context path to widget Root
        const widgetRoot = serverRoot + '/static/deutsche-bank-ui/widgets';
        const translationFileBaseURL = serverRoot + '/static/deutsche-bank-ui';
        const manifestFileName = '/rev-manifest.json';
        
        if (!this.cacheBustedFilesNames)
            this.getManifestFile(widgetRoot + manifestFileName);
       

        (<any>window).requirejs.config({
            paths: {
                [widget.id] :  widgetRoot + '/' + self.cacheBustedFilesNames[appBundleName]
            }
        });
        const genericBackbaseWidget = new EvoGenericWidget(
                    widget.id,
                    {
                        appBundleName: appBundleName,
                        appSelector: appSelector,
                    },                
                    widgetRoot,
                    widget.type,              
                    widget.props, 
                    elementWrapper           
                );
        (<any>window).requirejs(['angular', 'core', 'angular-translate', 'angular-dynamic-locale', widget.id], function(ng: any, core: any, angularTranslate: any, dynamicLocale: any, widgetModule: any) {
            // define the custom translate load factory
             widgetModule.factory('backbaseTranslateProvider', ["$http", "$q", "translationProps", self.backbaseTranslateProvider]);

            //provide custom lpwidget, lpcoretemplate and lpcorebus providers
            widgetModule.factory("widget", ["widgetInstance", self.lpWidgetProvider]);
            widgetModule.factory("lpWidget", ["widgetInstance" ,self.lpWidgetProvider]);
            widgetModule.factory("lpCoreTemplate", ["widgetInstance", self.lpCoreTemplateProvider]);
            widgetModule.factory("lpCoreBus", self.lpCoreBusProvider);

             // provide the widget service and use custom translate factory as loader to widget
             widgetModule.config(["$translateProvider", "tmhDynamicLocaleProvider", function ($translateProvider: any, tmhDynamicLocaleProvider: any) {
                 tmhDynamicLocaleProvider.localeLocationPattern(translationFileBaseURL +'/locales/ng-locale/angular-locale_{{locale}}.js');
                 $translateProvider.preferredLanguage("en-US");
                 $translateProvider.useLoader('backbaseTranslateProvider');
             }]);

            widgetModule.constant('translationProps', {
                    widgetRoot: genericBackbaseWidget.widgetRoot,
                    commonTranslationPath: translationFileBaseURL,
                    appBundleName: genericBackbaseWidget.attributes.appBundleName
            });
            widgetModule.value('widgetInstance', genericBackbaseWidget);
             ng.bootstrap(elementWrapper, [widgetModule.name]);
         });

    }

    private initiateLatestAngularWidget(widget: EvoGenericWidget, elementWrapper: HTMLElement): void {
        
        // Build an isolated, widget instance specific requirejs context
        // This will load and execute the widget instance JS
        const statsName = 'stats';
        const appBundleName = widget.attributes.appBundleName;
        const widgetRoot = widget.widgetRoot || '/widgets';
        const config = {
            context: widget.id,
            paths: {
                [statsName]: widgetRoot + '/' + appBundleName + '/' + statsName
            },
            waitSeconds: 0
        };
        let widgetContext: any = (<any>window).requirejs.config(config);

        widgetContext([statsName], function (stats: any) {
            widgetContext = (<any>window).requirejs.config({
                context: widget.id,
                paths: {
                    'inline': widgetRoot + '/' + appBundleName + '/' + stats.inline,
                    'main': widgetRoot + '/' + appBundleName + '/' + stats.main
                }
            });

            // load the angular scripts
            widgetContext(['inline'], function () {
                widgetContext(['main'], function () {
                });
            });
        });

    }

    private backbaseTranslateProvider($http: any, $q: any, translationProps: any) {
        // return loaderFn
        return function (options: any) {
            let data:any = {};
            let deferred = $q.defer();
            // load translation files.
            const commonTranslationsPromise = $http.get(translationProps.commonTranslationPath + '/locales/common.json', {cache: true});
            const widgetsTranslationsPromise = $http.get(translationProps.widgetRoot + '/' + translationProps.appBundleName + '/locale/all.json');
            $q.all([commonTranslationsPromise, widgetsTranslationsPromise]).then(function(result: any) {
                for(let i=0; i< result.length; i++) {
                   (<any>window).angular.merge(data, result[i].data);
                }
                // resolve with translation data
                return deferred.resolve(data[options.key]);
            }).catch(function(){
                // or reject with language key
                return deferred.reject(options.key);
            });
            return deferred.promise;
        };
    }    

    private lpWidgetProvider(widgetInstance: EvoGenericWidget) {
        return widgetInstance.getLPWidgetInstance();
    }

    private lpCoreTemplateProvider(widgetInstance: EvoGenericWidget) {
        return widgetInstance.getLpCoreTemplateInstance();
    }

    private lpCoreBusProvider() {
       // return widgetInstance.getLpCoreBusInstance();
       return Object.create( {
            publish: (<any>window).gadgets.pubsub.publish,
            subscribe: (<any>window).gadgets.pubsub.subscribe,
            unsubscribe: (<any>window).gadgets.pubsub.publish,
            flush: (<any>window).flush
        });
    }

    private getManifestFile(url: string) {        
        SimpleHttp('GET', url, (result: {[key: string]: string}) => {
            this.cacheBustedFilesNames = result;
        }, false);
    }
    
    
}